// extracted by mini-css-extract-plugin
export default {"lds-hourglass":"style_lds-hourglass__3d7D4","lds-hourglass-after":"style_lds-hourglass-after__miHw9"};